import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faYoutube,
  faInstagram,
  faFacebook,
  faXTwitter,
  faRedditAlien
} from '@fortawesome/free-brands-svg-icons';

export const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Qinto - Buy & Sell with AI</h4>
          <p>A local marketplace to buy and sell used items more easily with AI-powered listings</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <div className="footer-links">
            <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link>
            <Link to="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
            <Link to="/blog" target="_blank" rel="noopener noreferrer">Visit our blog</Link>
            <Link to="/faq" target="_blank" rel="noopener noreferrer">Help & FAQ</Link>
          </div>
        </div>


        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-links">
            
            
            <a href="https://instagram.com/qinto.in" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61585049194040" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebook} size="2x" />
            </a>
            <a href="https://www.youtube.com/@qintoapp" target="_blank" rel="noopener noreferrer" aria-label="Youtube">
              <FontAwesomeIcon icon={faYoutube} size="2x"  />
            </a>
            <a href="https://reddit.com/r/qinto" target="_blank" rel="noopener noreferrer" aria-label="Reddit">
              <FontAwesomeIcon icon={faRedditAlien} size="2x" />
            </a>
            <a href="https://x.com/qintoapp" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
              <FontAwesomeIcon icon={faXTwitter} size="2x" />
            </a>
            
          </div>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h4>Contact</h4>
          <a
            href="https://wa.me/916305066105"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-link"
          >
            💬 WhatsApp Us
          </a>
          <p style={{marginTop: '15px',}}>
            <span style={{fontWeight: '600'}}>Email: </span>info@qinto.in
            </p>
          <p><span style={{fontWeight: '600'}}>Location: </span> Hyderabad, India</p>
          <p>Response time: within 24-48 hours</p>
        </div>

        <div className="footer-section">
          <h4>Available</h4>
          <div className="app-badges">
            <a href="https://play.google.com/store/apps/details?id=com.qinto.qintoapp" target="_blank" rel="noopener noreferrer" className="app-badge">
              <img src="/logos/google-play-svgrepo-com.png" alt="Play Store Logo" className='logo-play-store' />
              <div className="app-badge-text">
                <span>Get it on</span>
                <strong>Google Play</strong>
              </div>
            </a>
          </div>
          <div style={{ height: '10px', marginTop: '15px' }}></div>
          <h4>Coming soon on</h4>
          <div className="app-badges">
            <a href="https://apple.com/app-store" target="_blank" rel="noopener noreferrer" className="app-badge">
              <img src="/logos/apple-173-svgrepo-com.png" alt="App Store Logo" className='logo-play-store' />
              <div className="app-badge-text">
                <span>Download from</span>
                <strong>App Store</strong>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025-2026 Qinto Marketplace. All rights reserved.</p>
        <p>Udyam Registered | Qinto | Registration No. UDYAM-TS-02-0327828</p>
      </div>
    </div>
  </footer>
);